import React, { useRef, useState } from 'react';
import './HorizontalImageScroller.css';

const HorizontalImageScroller = ({ basePath = '/bbkandy/images/rooms/6bed/screens', imageCount = 10 }) => {
  const scrollContainerRef = useRef(null);
  const scrollBarRef = useRef(null);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [lightboxImg, setLightboxImg] = useState(null);

  const handleScroll = () => {
    const el = scrollContainerRef.current;
    const scrollPercent = el.scrollLeft / (el.scrollWidth - el.clientWidth);
    setScrollPercent(scrollPercent);
  };

  const handleBarDrag = (e) => {
    const container = scrollContainerRef.current;
    const containerRect = container.getBoundingClientRect();

    const onMouseMove = (moveEvent) => {
      const relX = moveEvent.clientX - containerRect.left;
      const newPercent = Math.min(Math.max(relX / container.clientWidth, 0), 1);
      container.scrollLeft = newPercent * (container.scrollWidth - container.clientWidth);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    e.preventDefault();
  };

  const openLightbox = (src) => {
    setLightboxImg(src);
  };

  const closeLightbox = () => {
    setLightboxImg(null);
  };

  return (
    <>
      <div className="gallery-wrapper">
        <div
          className="scrollable-gallery"
          ref={scrollContainerRef}
          onScroll={handleScroll}
        >
          <ul className="slides">
            {Array.from({ length: imageCount }).map((_, index) => {
              const num = index + 1;
              const imgSrc = `${basePath}/${num}.webp`;
              return (
                <li key={num} className="gallery-item">
                  <div className="gallery-image" style={{ cursor: 'pointer' }} onClick={() => openLightbox(imgSrc)}>
                    <img
                      src={imgSrc}
                      alt={`Slide ${num}`}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="custom-scrollbar">
          <div
            className="scroll-handle"
            ref={scrollBarRef}
            onMouseDown={handleBarDrag}
            style={{ left: `${scrollPercent * 100}%` }}
          ></div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxImg && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>×</button>
            <img src={lightboxImg} alt="Full view" />
          </div>
        </div>
      )}
    </>
  );
};

export default HorizontalImageScroller;
